import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  PageData,
  PageDataStatus,
  FetchStateType,
  getFetchStateChange,
} from "../../models";
import { DisputeListData, DisputeData } from "./types";

type DisputesData = {
  all?: DisputeData[];
  displayData?: DisputeData[];
  currentPage?: PageData<DisputeListData>;
  displayedDispute?: DisputeData;
  fetchState: FetchStateType;
  cancelFetchState: FetchStateType;
  downloadReportFetchState: FetchStateType;
};

const initialState: DisputesData = {
  cancelFetchState: { type: "not-started" },
  fetchState: { type: "not-started" },
  downloadReportFetchState: { type: "not-started" },
};

const name = "disputes";

const disputesSlice = createSlice({
  name,
  initialState,
  reducers: {
    setDisputes: (state, action: PayloadAction<PageData<DisputeListData>>) => ({
      ...state,
      currentPage: action.payload,
    }),

    setDisplayed: (state, action: PayloadAction<DisputeData | undefined>) => ({
      ...state,
      displayedDispute: action.payload,
    }),

    invalidateDispute: (state) => {
      if (!state.currentPage) return state;

      return {
        ...state,
        currentPage: {
          ...state.currentPage,
          status: PageDataStatus.DataInvalidated,
        },
      };
    },

    setFetchState: (state, action: PayloadAction<FetchStateType>) => ({
      ...state,
      displayedDispute:
        action.payload.type === "successful"
          ? undefined
          : state.displayedDispute,
      all: action.payload.type === "successful" ? undefined : state.all,
      displayData:
        action.payload.type === "successful" ? undefined : state.displayData,
      fetchState: getFetchStateChange(state.fetchState, action.payload),
      downloadReportFetchState: action.payload,
    }),
    setCancelDisputeFetchState: (
      state,
      action: PayloadAction<FetchStateType>
    ) => ({
      ...state,
      cancelFetchState: action.payload,
    }),
    setDownloadFetchState: (
      state,
      action: PayloadAction<FetchStateType>
    ) => ({
      ...state,
      downloadReportFetchState: action.payload,
    }),
  },
});

export const {
  setDisputes,
  setDisplayed,
  invalidateDispute,
  setFetchState,
  setCancelDisputeFetchState,
  setDownloadFetchState,
} = disputesSlice.actions;

export default disputesSlice.reducer;
